import json from './dump.json'

let cumulObject = {}
json.map((element,index)=>{
    let newObject = {}
    if (element.unknown && element.params) {
        let name = element.unknown[0].tagValue
        //attrsObj[name] = 
        let propertiesArray = []
        element.params.map((item, index2)=>{
            let arrayItem = {
                label: item.name,
                description: item.description,
                value: item.types[0],
                defaultValue: ''
            }
            propertiesArray.push(arrayItem)
        })
        newObject[name] =  {
            label: name,
            path: 'dnx-path',
            description: element.description,
            properties: propertiesArray
        }
    }
    cumulObject = Object.assign(cumulObject, newObject)
})

export default cumulObject


// WEBPACK FOOTER //
// ./src/doc/docParser.js